import "./styles.scss";
import { useIntl } from "react-intl";
import { formatDateOnlyString } from "../../../../utils/dateUtils";
import { getMaintenanceGroupLabel } from "../enums/maintenanceGroupEnum";

export interface IInfoProps {
  chassis?: string;
  model?: string;
  maintenanceGroup?: string;
  licensePlate?: string;
  contractNumber?: string;
  contractType?: string;
  accountName?: string;
  startAt?: string;
  endAt?: string;
  activationDate?: string;
  odometer?: number;
  hourmeter?: number;
}

const Info = ({
  chassis,
  model,
  maintenanceGroup,
  licensePlate,
  contractNumber,
  contractType,
  accountName,
  startAt,
  endAt,
  activationDate,
  odometer,
  hourmeter,
}: IInfoProps) => {
  const intl = useIntl();

  return (
    <section className="margin-bottom-20 contract-details-info">
      <div className="contract-details-info__grid">
        <div className="contract-details-info__row">
          <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.info.chassis" })}:</span>
          <span className="contract-details-info__value truncate">{chassis}</span>
        </div>
        <div className="contract-details-info__row">
          <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.info.contractType" })}:</span>
          <span className="contract-details-info__value truncate">{contractType}</span>
        </div>
        <div className="contract-details-info__row">
          <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.info.contractNumber" })}:</span>
          <span className="contract-details-info__value truncate">{contractNumber}</span>
        </div>

        <div className="contract-details-info__row">
          <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.info.model" })}:</span>
          <span className="contract-details-info__value truncate">{model}</span>
        </div>
        <div className="contract-details-info__row">
          <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.info.licensePlate" })}:</span>
          <span className="contract-details-info__value truncate">{licensePlate}</span>
        </div>
        <div className="contract-details-info__row">
          <span className="contract-details-info__label">{odometer ? intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.info.odometer" }) : hourmeter ? intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.info.hourmeter" }) : ""}</span>
          <span className="contract-details-info__value truncate">{odometer ? `${odometer.toLocaleString("pt-BR")} km` : hourmeter ? `${hourmeter.toLocaleString("pt-BR")} h` : ""}</span>
        </div>
        
        <div className="contract-details-info__row">
          <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.info.warrantyStartDate" })}:</span>
          <span className="contract-details-info__value truncate">{startAt ? formatDateOnlyString(startAt) : "—"}</span>
        </div>        
        <div className="contract-details-info__row">
          <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.info.validity" })}:</span>
          <span className="contract-details-info__value truncate">{startAt && endAt ? `${formatDateOnlyString(startAt)} - ${formatDateOnlyString(endAt)}` : "—"}</span>
        </div>
        <div className="contract-details-info__row">
          <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.info.activationDate" })}:</span>
          <span className="contract-details-info__value truncate">{activationDate ? formatDateOnlyString(activationDate) : "—"}</span>
        </div>

        <div className="contract-details-info__row">
          <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.info.accountName" })}:</span>
          <span className="contract-details-info__value truncate">{accountName}</span>
        </div>
        <div className="contract-details-info__row">
          <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.info.maintenanceGroup" })}:</span>
          <span className="contract-details-info__value truncate">{getMaintenanceGroupLabel(maintenanceGroup)}</span>
        </div>

      </div>
    </section>
  );
};

export default Info;
